import React from 'react';

const EmptyView = () => (
	<>{/* Because of the system dashboard, there can never be no dashboard */}</>
);

export default EmptyView;
